import { render, staticRenderFns } from "./FlexIp.vue?vue&type=template&id=56ea2099"
import script from "./FlexIp.vue?vue&type=script&lang=js"
export * from "./FlexIp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports